import { CONFIG_OPTION_TOAST_ERROR } from "common/toast";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AsyncPaginate, wrapMenuList } from "react-select-async-paginate";
import { components } from "react-select";
import { toast } from "react-toastify";
import { ceil } from "lodash";
import NO_IMAGE from "../../assets/images/users/ic_defaul_avatar2.png";
import {
  COLOR_USER_TYPE_LOG,
  getPlatFormImage,
  USER_TYPE_LOG_OPTION,
} from "helpers/constans";
import { capitalizeFirstLetter } from "utils";
import PushNotificationApi from "api/pushNotificationApi";

interface Option {
  label: string | any;
  value: string;
}
interface DropdownOptionProps {
  name?: string;
  listCheckedUsers?: string | null;
  debounceTimeout?: number;
  onChangeSelect?: (params: Option) => void;
  isMulti?: boolean;
  placeholder?: string;
  isShowIconCheck?: boolean;
  hideSelectedOptions?: boolean;
  isAllOption?: boolean;
  paramsTypeUsers?: number;
  isDisabled?: boolean;
  keywordSearch?: string;
  isHideBatenderNull?: boolean;
  defaultParams?: any;
  isClearable?: boolean;
  isShowAvatar?: boolean;
  isShowOnManualPush?: boolean;
}
const LIMIT = 30;

export const LabelUserOption = ({user} : {user: any}) => {
  const { t } = useTranslation();

  let platform = user?.provider_type;
  let imgPlatform = getPlatFormImage(platform);

  return (
    <div className="d-flex align-items-center gap-2">
      <div
        style={{
          height: "30px",
          width: "30px",
          minWidth: "30px",
          overflow: "hidden",
          borderRadius: "15px",
          objectFit: "cover",
          backgroundColor: "#eaeaea",
          // zIndex: 99,
        }}
      >
        <img
          src={user?.profile_image_url || NO_IMAGE}
          alt={user?.nickname}
          height={30}
          width={30}
          style={{
            minWidth: "30px",
            overflow: "hidden",
            borderRadius: "50%",
            objectFit: "cover",
            backgroundColor: "#eaeaea",
          }}
        />
      </div>
      <div>
        <div className="text-left d-flex align-items-center">
          <small
            className={`rounded-pill badge bg-${
              COLOR_USER_TYPE_LOG[user?.type] || "secondary"
            }`}
          >
            {t(
              USER_TYPE_LOG_OPTION?.find(
                (item: any) => item?.value === String(user?.type)
              )?.label || ""
            )}
          </small>
          <small className="px-1"> | </small>
          <small className="d-flex gap-1">
            {imgPlatform && (
              <img
                src={imgPlatform}
                width={16}
                height={16}
                alt="platform"
              />
            )}
            {t(
              capitalizeFirstLetter(
                platform === "default" || platform === "guest"
                  ? "Email"
                  : platform
              )
            )}
          </small>
          {user?.udid_2 && (
            <>
              <small className="px-1"> | </small>
              <small>{user?.udid_2}</small>
            </>
          )}
        </div>

        <div>
          {`${user?.nickname ? user?.nickname + " -" : ""} ${user?.email}`}
        </div>
      </div>
    </div>
  )
};

const DropdownAsyncUsers = ({
  name = "",
  listCheckedUsers,
  debounceTimeout = 700,
  onChangeSelect,
  isMulti = false,
  placeholder,
  isShowIconCheck = false,
  hideSelectedOptions = true,
  isAllOption = false,
  paramsTypeUsers = 2,
  isDisabled = false,
  keywordSearch = "",
  isHideBatenderNull,
  defaultParams = {},
  isClearable = true,
  isShowAvatar = false,
  isShowOnManualPush = false,
}: DropdownOptionProps) => {
  const { t } = useTranslation();
  // const [isAllCheckedUsers, setIsAllCheckedUsers] = useState(false);
  const [options, setOptions] = useState([]);

  const setOnChangeOption = (item: any) => {
    onChangeSelect && onChangeSelect(item);
  };

  const loadListUsers = async ({
    page,
    limit,
    search,
  }: {
    page: number;
    limit: number;
    search?: string;
  }) => {
    let params: any = {
      page,
      limit,
      keyword: search,
      ...(isShowOnManualPush === false ? { type: paramsTypeUsers } : null),
      ...defaultParams,
    };

    if (keywordSearch) {
      params = {
        page,
        limit,
        keyword: search,
        type: paramsTypeUsers,
        bar_id: keywordSearch,
        ...defaultParams,
      };
    }

    const {
      data: { list, meta },
      code,
    } = await PushNotificationApi.getNotificationUsers(params);

    if (!code) {
      return { success: false };
    }

    const dataUsersOptions = list?.map((a: any) => {
      if (isShowOnManualPush) {
        return {
          value: String(a?.id),
          label:  <LabelUserOption user={a} />,
          data: a,
        };
      }

      return {
        value: String(a?.id),
        label: (
          <div className="d-flex align-items-center gap-2">
            {isShowAvatar && (
              <div
                style={{
                  height: "22px",
                  width: "22px",
                  minWidth: "22px",
                  overflow: "hidden",
                  borderRadius: "15px",
                  objectFit: "cover",
                  backgroundColor: "#eaeaea",
                  zIndex: 99,
                }}
              >
                <img
                  src={a?.profile_image_url || NO_IMAGE}
                  alt={a?.nickname}
                  height={22}
                  width={22}
                  style={{
                    minWidth: "22px",
                    overflow: "hidden",
                    borderRadius: "50%",
                    objectFit: "cover",
                    backgroundColor: "#eaeaea",
                  }}
                />
              </div>
            )}
            <div>{`${a?.nickname ? a?.nickname + " -" : ""} ${a?.email}`}</div>
          </div>
        ),
        data: a,
      };
    });

    return {
      code,
      dataUsersOptions: dataUsersOptions || [],
      lastPage: ceil(meta?.total / meta?.limit),
    };
  };

  async function loadOptions(
    search: string,
    loadedOptions: any[],
    { page }: { page: number }
  ) {
    const { code, dataUsersOptions, lastPage } = await loadListUsers({
      page,
      limit: LIMIT,
      search,
    });
    let dataUsersOptionsFormat = dataUsersOptions || [];

    if (code !== 200) {
      toast(`${t("Failed to load data")}`, CONFIG_OPTION_TOAST_ERROR);
      return {
        options: [],
        hasMore: false,
      };
    }
    let lastPageFormat = lastPage ? lastPage : 1;
    let options = isAllOption
      ? [
          ...(page === 1 ? [{ label: t("All Filter"), value: "all" }] : []),
          ...dataUsersOptionsFormat,
        ]
      : dataUsersOptionsFormat;

    setOptions(options);

    return {
      options: options,
      hasMore: lastPageFormat > page,
      additional: {
        page: page + 1,
      },
    };
  }

  const MenuList = (props: any) => {
    let childComponent = props?.children;
    if (props?.children?.length > 0) {
      const allOption = props?.children?.filter(
        (item: any) => item?.props?.value === "all"
      );
      let fixedIndex = -1;
      if (allOption) {
        fixedIndex = props?.children.indexOf(allOption?.[0]);
      }
      const fixedElement = props?.children?.[fixedIndex];

      const childComponentFormat = (
        (fixedIndex !== -1 ? props?.children.slice(1) : props?.children) || []
      )?.sort((a: any, b: any) => {
        let pointA = a.props.isSelected === true ? 1 : 0;
        let pointB = b.props.isSelected === true ? 1 : 0;
        return pointB - pointA;
      });

      if (fixedElement) {
        childComponent = [fixedElement, ...childComponentFormat];
      } else {
        childComponent = childComponentFormat;
      }
    }

    return (
      <components.MenuList {...props}>{childComponent}</components.MenuList>
    );
  };

  let isAllCheckedUsers = false;
  const OptionFormat = (props: any) => {
    if (props?.isSelected && props?.value === "all") {
      isAllCheckedUsers = true;
    } else if (!props?.isSelected && props?.value === "all") {
      isAllCheckedUsers = false;
    }

    return (
      <components.Option {...props} style={{ zIndex: 999 }}>
        <div className="d-flex align-items-center gap-2">
          {(props?.isSelected || isAllCheckedUsers) && isShowIconCheck ? (
            <i className="ri-check-line align-middle fs-14" />
          ) : (
            ""
          )}
          {props.data?.label}
        </div>
      </components.Option>
    );
  };

  const MenuListAsync = wrapMenuList(MenuList);

  useEffect(() => {
    if (keywordSearch) {
      // setOptions([])
      loadOptions(keywordSearch, [], { page: 1 });
    }
  }, [keywordSearch]);

  return (
    <AsyncPaginate
      name={name}
      isMulti={isMulti}
      isClearable={isClearable}
      // defaultOptions
      options={options}
      debounceTimeout={debounceTimeout}
      value={listCheckedUsers}
      loadOptions={loadOptions}
      placeholder={placeholder}
      className="dropdown-status-rounded"
      hideSelectedOptions={false}
      onChange={(e: any) => setOnChangeOption(e)}
      additional={{
        page: 1,
      }}
      components={{
        Option: OptionFormat,
        // ...(isMulti ? { MenuList: MenuListAsync } : null),
        // MenuList: MenuListAsync,
      }}
      closeMenuOnSelect={hideSelectedOptions}
      menuPortalTarget={document.body}
      styles={{
        option: (styles: any) => {
          let styleNew = isMulti
            ? {
                ...styles,
                backgroundColor: "white",
                zIndex: 99,
                color: "black",
              }
            : styles;

          return styleNew;
        },
        control: (styles: any, { isFocused }: any) => {
          return {
            ...styles,
            borderColor: "#e9ebec",
            borderRadius: "0.6rem",
            color: "white",
            "&:hover": { borderColor: "#009ef7" },
          };
        },
        multiValue: (styles: any) => {
          return {
            ...styles,
            backgroundColor: "#009ef7",
          };
        },
        multiValueLabel: (styles: any) => ({
          ...styles,
          color: "white !important",
        }),
        menuPortal: (base: any) => ({
          ...base,
          zIndex: 1051,
        }),
      }}
      isDisabled={isDisabled}
    />
  );
};

export default DropdownAsyncUsers;
